import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/userContext';

export default function ProtectedRoute({ children, requiredRole }) {
  const { userDetails, isLoding } = useContext(UserContext);


  if (isLoding) {
    return <div>Loading...</div>;
  }

  if (!userDetails) {
    return <Navigate to="/account/login" replace />;
  }

  if (requiredRole && userDetails.role !== requiredRole) {
    return <Navigate to="/accessDenied" replace />;
  }

  return children;
}
